export const QUESTION = 'question';
export const SCREEN = 'screen';
